// extracted by mini-css-extract-plugin
export default {"tableContainer":"UserTable_tableContainer__DeyoB","tableRoot":"UserTable_tableRoot__TAJr4","tableBodyRow":"UserTable_tableBodyRow__qnV5g"};